module.exports = __webpack_public_path__ + "img/time-blue.f6380771.svg";